import { Box, Container, Grid, Typography } from "@mui/material";
import "./Gracias.css";
import appstore from '/images/App_Store.png';
import googleplay from '/src/assets/Google_Play.png';
import React from "react";

function Gracias() {
  return (
    <Container maxWidth="md" sx={{ marginTop: "10vh", marginBottom: { sx: "300px", md: "0px" } }}>
      <Grid container spacing={2} justifyContent="center">
        {/* Mensaje principal */}
        <Grid item xs={12} textAlign={"center"} style={{ marginTop: '10px' }}>
          <Typography variant="h4" textAlign="center" sx={{ fontWeight: 700 }}>
            ¡Bienvenido a Banco Columbia!
          </Typography>
        </Grid>

        <Grid item xs={12} textAlign="center">
          <Box width="75%" sx={{ margin: "auto" }}>
            <Typography variant="body1" sx={{ textAlign: 'center', fontWeight: 500 }}>
              Hola, ya podés continuar con el proceso de validación de identidad. Una vez completado este paso, en un plazo de{" "}
              <strong>48 horas</strong> podrás usar tu tarjeta digital desde nuestra app.
            </Typography>
          </Box>
        </Grid>

        {/* Descarga de la app */}
        <Grid item xs={12} textAlign="center">
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            📲 Descárgala aquí:
          </Typography>
        </Grid>

        {/* Botones de descarga */}
        <Grid item xs={12} textAlign="center">
          <Box display="flex" justifyContent="center" gap={2}>
            <Box
              // component="a"
              // href="https://apps.apple.com/us/app/columbia-banco-movil/id6498297113"
              // target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                component="img"
                src={appstore}
                alt="Descargar en App Store"
                sx={{ width: "150px" }}
              // sx={{ width: "150px", cursor: "pointer" }}
              />
            </Box>

            <Box
              // component="a"
              // href="https://play.google.com/store/apps/details?id=ar.com.bancocolumbia.bancomovil"
              // target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                component="img"
                src={googleplay}
                alt="Disponible en Google Play"
                sx={{ width: "150px" }}
              // sx={{ width: "150px", cursor: "pointer" }}
              />
            </Box>
          </Box>
        </Grid>

        {/* Mensaje final */}
        <Grid item xs={12} textAlign="center">
          <Typography variant="body1" sx={{ fontWeight: 500, marginTop: "10px" }}>
            y comenzá a disfrutar todos sus beneficios.
          </Typography>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Typography variant="body1" sx={{ fontWeight: 500, marginTop: "10px" }}>
            <strong>¡Gracias por elegirnos!</strong>
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Gracias;
